import React, { useEffect, useState } from 'react';

import { Box } from '@mui/material';
import { Button } from 'semantic-ui-react';

import OhsSelectFieldPair from 'global-components/form/fields/OhsSelectFieldPair';
import { OhsFormSettings, OhsFormLayoutType } from 'global-components/form/services/OhsFormModels';
import {
  OhsCategoryOtherRecordField,
  OhsCategoryRecordField,
  OhsCusvalsRecordField,
} from 'global-services/constants/record-field/OhsGlobalRecordFiled';
import OhsCategoryCusvalFieldsSectionContent from 'global-components/form/cusvals/OhsCategoryCusvalFieldsSectionContent';
import { OhsCusval } from 'global-components/form/cusvals/OhsCusvalModel';

import { fullCusvalConfig1, fullCusvalConfig2, fullCusvalValueInvalid1 } from '../testData';

let renderCounter = 0;

function CategoryCusvalInvalid() {
  const [data, setData] = useState({});
  const [cusvalsConfig, setCusvalsConfig] = useState<OhsCusval[] | null>(fullCusvalConfig1);
  const ohsFormSettings = new OhsFormSettings(
    {
      category: 'Category 1',
      cusvals: fullCusvalValueInvalid1,
    },
    OhsFormLayoutType.AngularPageForm
  );
  const [category]: [string] = ohsFormSettings.useFormMethods.watch([OhsCategoryRecordField.key]);

  const categoryOptions = [
    { name: 'Category 1', value: 'Category 1' },
    { name: 'Category 2', value: 'Category 2' },
  ];

  useEffect(() => {
    if (category === 'Category 1') setCusvalsConfig(fullCusvalConfig1);
    if (category === 'Category 2') setCusvalsConfig(fullCusvalConfig2);
  }, [category]);

  renderCounter += 1;

  return (
    <Box width="100%">
      <p>When editing:</p>
      <p>1. cusvalId exists</p>
      <p>2. currentCusvalDefId exists</p>
      <p>3. cusvalValues exists</p>
      <p>4. cusvalValues have values that no longer exists in config</p>
      <p>Expected:</p>
      <p>
        When there are cusvals that have been removed in a config, but old record still has it,
        these fields will be labelled &quot;for deletion&quot;
      </p>

      <Box mb={4}>
        <OhsSelectFieldPair
          selectProps={{
            title: OhsCategoryRecordField.name,
            id: OhsCategoryRecordField.key,
            required: true,
            options: categoryOptions,
          }}
          textProps={{
            type: 'text',
            title: OhsCategoryOtherRecordField.name,
            id: OhsCategoryOtherRecordField.key,
            required: true,
          }}
          ohsFormSettings={ohsFormSettings}
        />
      </Box>
      <OhsCategoryCusvalFieldsSectionContent
        cusvalId={category}
        ohsFormSettings={ohsFormSettings}
        id={OhsCusvalsRecordField.key}
        categoryName={OhsCategoryRecordField.name}
        initRecordValue="Category 1"
        initialOptions={categoryOptions}
        cusvalsConfig={cusvalsConfig}
        isInitCusvalConfigFetched
      />

      <Box mt={4} display="flex" justifyContent="end" width="100%">
        <Button
          id="submit"
          onClick={ohsFormSettings.useFormMethods.handleSubmit((formData: any) => {
            setData(formData);
          })}
          color="green"
        >
          Submit
        </Button>
      </Box>

      <div id="renderCount">Render Count: {renderCounter}</div>

      <pre>{JSON.stringify(data, null, 4)}</pre>
    </Box>
  );
}

export default CategoryCusvalInvalid;
